import React from 'react';
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import Header from "../../Layouts/Header";
import Navbar from "../../Layouts/Navbar";
import API from "../../Services/API";
import {toast} from "react-toastify";
import {useNavigate, useParams} from "react-router-dom";
import {HiOutlineLocationMarker, HiOutlineQrcode} from "react-icons/hi";
import {BsCalendar4Week} from "react-icons/bs";
import {TbCoin, TbStatusChange} from "react-icons/tb";
import Balad from "../../Assets/Images/balad.png"
import Nehan from "../../Assets/Images/neshan.png"
import Gmap from "../../Assets/Images/gmap.png"
import {CiMoneyBill, CiPercent} from "react-icons/ci";
import {GiTwoCoins} from "react-icons/gi";
import Logo from "../../Assets/Images/logo.png";
import {MdOutlineCancel, MdOutlinePayment, MdVerified} from "react-icons/md";
import {FaUser} from "react-icons/fa";
import PaymentHistory from "./PaymentHistory";

let totalPrice = 0;
const currencyFormat = Intl.NumberFormat('en-US');

function Request() {
    const navigate = useNavigate();
    const {id} = useParams();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [routing, setRouting] = React.useState(false);
    const [request, setRequest] = React.useState([]);
    const [trackingCode, setTrackingCode] = React.useState('');
    const [price, setPrice] = React.useState(0);
    const [confirmPay, setConfirmPay] = React.useState(0);
    const [payableAmount, setPayableAmount] = React.useState(0);


    React.useEffect(() => {
        totalPrice = 0;
        setIsLoaded(false)
        const params = {
            access_mode : 'Servitor'
        }

        API.getRequest(params , id)
            .then((response) => {
                setRequest(response.data);
                if (response.data.service_payable_amount > 0) {
                    setPayableAmount(response.data.service_payable_amount + response.data.transportation_amount - response.data.payed_amount);
                }
                else {
                    setPayableAmount(response.data.prepayment_amount + response.data.transportation_amount - response.data.payed_amount);
                }
                const tc = response.data.tracking_code;
                setTrackingCode(tc.substring(0,tc.length -1))
                response.data.details.forEach(element => {
                    totalPrice += parseInt(element.service_price *  element.count);
                });
                setIsLoaded(true);
            })
            .catch((error) => {
                if(error.response) {
                    toast.error(error.response.data.message);
                }
                else {
                    toast.error(error.message);
                }
            });


    }, [id,price]);

    const onEditClick = () => {
        const details = request.details;
        let cartItems = [];
        Object.keys(details).forEach(function(key) {
            const detail = details[key];
            cartItems.push({'item': detail.service.id, 'number': detail.count})
        });
        window.localStorage.setItem("cart", JSON.stringify(cartItems));
        window.localStorage.setItem("companyID", request.company.id);
        window.localStorage.setItem("requestID", id);
        navigate(`/company/${request.company.id}`);
    }

    const onStoreRequest = () => {

        if(trackingCode.length < 4) {
            toast.error('شماره رهگیری را کامل وارد کنید');
            return false;
        }


        if (request.next_step.id === '9' && trackingCode !== request.tracking_code) {
            toast.error('شماره رهگیری را درست وارد کنید');
            return false;
        }

        if (payableAmount > 0) {
            if (request.next_step.id === '9'  && !confirmPay) {
                toast.error(' لطفا ابتدا از مشتری بخواهید مبلغ را پرداخت کند یا تایید پرداخت نقدی مشتری را بزنید');
                return false;
            }
        }



        setIsLoaded(false);

        const params = {
            tracking_code : trackingCode,
            status_id  : request.next_step.id,
            request_id : id,
            cash_pay: confirmPay
        }
        API.updateRequest(params)
            .then((response) => {
                toast.success(response.message);

                window.localStorage.clear();
                setTimeout (() => {
                    setIsLoaded(true);
                    window.location.replace(`/requests`);
                },1500)
            })
            .catch((error) => {
                if(error.response) {
                    setIsLoaded(true);
                    toast.error(error.response.data.message);
                }
                else {
                    setIsLoaded(true);
                    toast.error(error.message);
                }
            });
    }

    return (
        <React.Fragment>
            <Toast />
            {
                !isLoaded && <Loading />
            }
            <Header title='مشاهده درخواست' hasBack={true} />

            {
                routing ?
                    <section className="container-fluid pt-5 mt-5 w-100 max-w-lg modal-bg border-top" id='map-selector'>
                        <div className="row">
                            <div className="col-12 mt-2">
                                <button className="btn btn-success w-100 small"
                                        onClick={() => {
                                            setRouting(false)
                                            window.open(`https://maps.neshan.org/@${request.address.lat},${request.address.long},14.5z,0.0p/routing/external=true`)
                                        }}
                                >
                                    <img src={Nehan} alt="neshan" width='32' className='float-right'/>
                                    مسیریابی با نقشه نشان
                                </button>
                            </div>
                            <div className="col-12 mt-3">

                                <button className="btn btn-dark w-100 small"
                                        onClick={() => {
                                            setRouting(false)
                                            window.open("http://maps.google.com/maps?saddr=&daddr=" + request.address.lat + "," + request.address.long + "&external=true")
                                        }}
                                >
                                    <img src={Gmap} alt="Google Map" width='32' className='float-right'/>
                                    مسیریابی با نقشه گوگل
                                </button>
                            </div>
                            <div className="col-12 mt-3">

                                <button className="btn btn-primary w-100"
                                        onClick={() => {
                                            setRouting(false)
                                            window.open(`geo:${request.address.lat},${request.address.long}&external=true`)
                                        }}
                                >
                                    <img src={Balad} alt="Balad" width='32' className='float-right'/>
                                    مسیریابی با دیگر مسیریاب ها
                                </button>
                            </div>
                        </div>
                        <div className="row mt-5">
                            <div className="col-12 text-center pt-2 mt-5">
                                <img src={Logo} alt="Barsepar" width='120' />
                            </div>
                            <div className="col-12 py-3">
                                <button className="btn btn-outline-secondary text-secondary w-100 "
                                        onClick={() => {
                                            setRouting(false)
                                        }}
                                >
                                     بازگشت به اطلاعات درخواست
                                </button>
                            </div>
                        </div>

                    </section>
                    : ''
            }


            {
                isLoaded &&
                <section className="container-fluid  mt-3 py-5 rtl px-0   ">
                    <div className="row mx-2 mb-3 border-bottom pb-2">
                        <div className="col-1">
                            <HiOutlineQrcode/>
                        </div>
                        <div className="col-5 text-small-2">
                            شماره رهگیری
                        </div>
                        <div className="col-6 text-start fw-bold text-small-2">
                            {request.tracking_code}
                        </div>
                    </div>
                    <div className="row mx-2 mb-3 border-bottom pb-2">
                        <div className="col-1">
                            <FaUser/>
                        </div>
                        <div className="col-5 text-small-2">
                            مشتری
                        </div>
                        <div className="col-6 text-start fw-bold text-small-2">
                            {request.user?.first_name}
                            &nbsp;
                            {request.user?.last_name}
                            &nbsp;
                            ( <a className='text-small-1 text-decoration-none'
                                 href={`tel${request.user?.username}`}>{request.user?.username}</a>)

                        </div>
                    </div>
                    <div className="row mx-2 mb-3 border-bottom pb-2">
                        <div className="col-1">
                            <TbStatusChange/>
                        </div>
                        <div className="col-5 text-small-2">
                            وضعیت درخواست
                        </div>
                        <div className="col-6 text-start fw-bold text-small-2"
                             style={{color: request.last_status.color}}>
                            {request.last_status.title}
                        </div>
                        {request.last_status.description &&
                            <div className="col-12 pt-4 mt-2 text-center text-danger fw-bold text-small-3">
                                {request.last_status.description}
                            </div>
                        }
                    </div>

                    <div className="row mx-2 mb-3  pb-2">
                        <div className="col-1">
                            <BsCalendar4Week/>
                        </div>
                        <div className="col-5 text-small-2">
                            تاریخ مراجعه
                        </div>
                        <div className="col-6 text-start fw-bold text-small-2">
                            {request.doing_date}
                            <br/>
                            {request.doing_time}
                        </div>
                    </div>

                    <div className="row mx-2 mb-3 pb-2 custom-card">
                        <div className="col-1">
                            <HiOutlineLocationMarker/>
                        </div>
                        <div className="col-7 text-small-2 pt-1">
                            <b>{request.address.title}</b> :&nbsp;
                            {request.address.address}
                        </div>
                        <div className="col-4 text-start fw-bold text-small-2 pt-1">
                            <span className='btn btn-outline-primary text-small-2'
                                  onClick={() => {
                                      setRouting(true)
                                  }}
                            >
                                مسیریابی
                            </span>
                        </div>
                    </div>

                    <div className="row mx-2 mb-3 pb-2 custom-card">
                        <div className="col-1 mb-3">
                            <CiMoneyBill/>
                        </div>
                        <div className="col-11 text-small-2 fw-bold pt-1 mb-3">
                            فاکتور
                        </div>

                        <div className="col-1 text-small-1 text-center border-bottom py-2">
                            #
                        </div>
                        <div className="col-6 text-small-1 text-center border-bottom py-2">
                            عنوان
                        </div>
                        <div className="col-3 text-small-1 text-center border-bottom py-2">
                            فی
                        </div>
                        <div className="col-2 text-small-1 text-center border-bottom py-2">
                            تعداد
                        </div>

                        {

                            request.details.map((detail, index) => {

                                return (
                                    <React.Fragment key={index}>
                                        <div className="col-1 text-small-1 text-center border-bottom py-2">
                                            {index + 1}
                                        </div>
                                        <div className="col-6 text-small-1 text-center border-bottom py-2 fw-bold">
                                            {detail.service.title}
                                        </div>
                                        <div className="col-3 text-small-1 text-center border-bottom py-2">
                                            {currencyFormat.format(detail.service_price)}
                                        </div>
                                        <div className="col-2 text-small-1 text-center border-bottom py-2">
                                            {detail.count}
                                        </div>
                                    </React.Fragment>
                                )
                            })


                        }

                        <div className="col-12 mt-5">
                            <div className="finance-card">
                                <h3><MdOutlinePayment/> جزئیات مالی</h3>
                                <div className="finance-item">
                                    <span className="title"><CiMoneyBill/> هزینه خدمات</span>
                                    {
                                        request.service_payable_amount > 0 ?
                                            <span
                                                className="value">{currencyFormat.format(request.service_payable_amount)}
                                                {" "}
                                                ریال
                                    </span>
                                            :
                                            <span className='fw-bold text-small-2 text-warning'>
                                                هنوز تعیین نشده
                                            </span>
                                    }


                                </div>
                                <div className="finance-item">

                                    <span className="title"><CiMoneyBill/>مبلغ بیعانه (پیش پرداخت)</span>
                                    <span
                                        className="value">{currencyFormat.format(request.prepayment_amount)}
                                        {" "}
                                        ریال
                                    </span>

                                </div>
                                <div className="finance-item">

                                    <span className="title"><CiMoneyBill/>هزینه ایاب و ذهاب </span>
                                    <span
                                        className="value">{currencyFormat.format(request.transportation_amount)}
                                        {" "}
                                        ریال
                                    </span>

                                </div>
                                <div className="finance-item text-success">

                                    <span className="title "><CiMoneyBill/>مبلغ پرداخت شده </span>
                                    <span
                                        className="value">{currencyFormat.format(request.payed_amount)}
                                        {" "}
                                        ریال
                                    </span>

                                </div>

                                <div className="payable-amount">
                                    <span className="title">
                                        مبلغ قابل پرداخت
                                    </span>
                                    <span
                                        className="value">{currencyFormat.format(payableAmount)}
                                        {" "}
                                        ریال
                                    </span>
                                </div>

                                <PaymentHistory payments={request.payments}/>
                            </div>
                        </div>


                    </div>
                    {
                        request.next_step.id === "9" &&
                        <div className="row mx-2 mb-3  pb-2 custom-card">

                            <div className="col-12">
                                {
                                    payableAmount > 0 &&
                                    <button className='btn btn-warning text-small-3 float-start'
                                            onClick={() => {
                                                setPrice(price + 1)
                                            }}
                                    >
                                        بررسی مجدد وضعیت پرداخت مشتری
                                    </button>
                                }
                            </div>

                            {
                              (  payableAmount > 0 || request.pay_type === "نقدی" ) &&
                            <div className="col-12 mt-4 ">
                                <div className="alert alert-primary">
                                    <div className="custom-control ">

                                        <input type="checkbox"
                                               className="custom-control-input" id="returnAddress"
                                               placeholder=""
                                               checked={confirmPay}
                                               value={1}
                                               onChange={
                                                   () => {
                                                       setConfirmPay(1 - confirmPay);

                                                   }
                                               }

                                        />
                                        &nbsp; &nbsp;
                                        <label htmlFor="returnAddress"
                                               className="custom-control-label fw-bold text-dark">
                                            تایید پرداخت مشتری (پرداخت نقدی)
                                        </label>

                                        <p className='text-small-2 text-justify mt-3'>
                                            درصورتی که مشتری از طریق اپلیکیشن خود پرداخت را انجام نداده است (یا گزینه نقدی را انتخاب کرده است) می توانید پس
                                            از دریافت مبلغ درخواست به صورت نقدی با زدن این تایید دریافت نقدی را تایید
                                            کنید.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            }
                        </div>
                    }

                    <div className="file-list-container bg-white">
                        <h5>فایل‌های پیوست</h5>
                        {request.files && request.files.length > 0 ? (
                            <ul className="list-group list-group-flush">
                                {request.files.map((file, index) => (
                                    <li key={index}
                                        className="list-group-item file-item d-flex justify-content-between align-items-center">
                                        <div className="file-info d-flex align-items-center">
                                            <div className="file-icon">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                     viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                     strokeWidth="2"
                                                     strokeLinecap="round" strokeLinejoin="round">
                                                    <path
                                                        d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
                                                    <polyline points="13 2 13 9 20 9"></polyline>
                                                </svg>
                                            </div>
                                            <div>
                                                <h6 className="mb-0">{file.title || "فایل بارگزاری شده"}</h6>
                                                {file.description &&
                                                    <p className="mb-0 text-muted small">{file.description}</p>}
                                            </div>
                                        </div>
                                        <a
                                            href={file.path}
                                            download
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn btn-outline-primary btn-sm"
                                        >
                                            دانلود
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p className="text-muted">هیچ فایلی برای این درخواست پیوست نشده است.</p>
                        )}
                    </div>
                    {
                        request.next_step.id &&

                        <div className="row mt-4 px-3 text-small-2 pb-5 mb-4">
                            <div className="form-floating mb-3 col-12">
                                <input type="tel" className="form-control" id="floatingInput"
                                       placeholder="شماره رهگیری"
                                       value={trackingCode}
                                       onChange={(event) => {
                                           setTrackingCode(event.target.value)
                                       }}
                                />
                                <label htmlFor="floatingInput" className='pe-5'>
                                    شماره رهگیری را وارد کنید
                                    &nbsp;
                                    (
                                    شماره فعلی:
                                    &nbsp;
                                    {request.tracking_code}
                                    )
                                </label>
                            </div>

                            <div className="col-8 px-1">
                                <button className='btn btn-success w-100' onClick={onStoreRequest}>
                                    {
                                        request.next_step.title
                                    }
                                </button>
                            </div>
                 {/*           <div className="col-4 px-1">
                                {
                                    request.next_step.id !== '6' ?
                                        <button className='btn btn-outline-primary w-100 text-small-1'
                                                onClick={() => {
                                                    onEditClick()
                                                }}
                                        >
                                            ویرایش فاکتور
                                        </button> : ''}
                            </div>*/}
                        </div>
                    }

                </section>
            }

            <Navbar/>
        </React.Fragment>
    );
}

export default Request;